import React from 'react';
import styled from 'styled-components';

import { ButtonGroup } from '@/ui/ButtonGroup';
import {
  WrapStyled,
  ColumnStyled,
  StyledLabel,
  StyledCaption,
} from '@/features/course/admin/molecules/CourseSettingsModalForm/CourseSettingsModalForm';
import { Button } from '@/ui/Button';
import { color } from '@/components/Typography/v2';
import { EditModularLayoutVariant } from '@/features/course/admin/templates/CourseLayout';
import { RLearningType } from '@/store/v2';

const DeleteButtonStyled = styled(Button).attrs({ variant: 'secondary', size: 'large' })`
  border: 1px solid ${(p) => p.theme.colors.error.main};
  width: 100%;

  :hover {
    border: none;
    background-color: ${(p) => p.theme.colors.error.main};
  }

  :focus:not(:active) {
    border: none;
    outline: 1px solid ${(p) => p.theme.colors.error.main};
  }

  :active {
    border: none;
    background: ${(p) => p.theme.colors.neutral.onBackground};
    color: ${(p) => color(p.theme.colors.neutral.outline1)};
  }
`;

type CourseSettingsModalDeleteButtonProps = {
  onClick: VoidFunction;
  layoutVariant: EditModularLayoutVariant;
};

export const CourseSettingsModalDeleteButton = ({
  layoutVariant,
  onClick,
}: CourseSettingsModalDeleteButtonProps): JSX.Element => {
  const caption =
    layoutVariant === RLearningType.PracticalAssessment ? 'Permanently remove your assessment' : 'Permanently remove your course';

  return (
    <WrapStyled>
      <ColumnStyled>
        <ButtonGroup gap="small" direction="vertical">
          <StyledLabel>Delete</StyledLabel>
          <StyledCaption>{caption}</StyledCaption>
        </ButtonGroup>
      </ColumnStyled>
      <ColumnStyled>
        <DeleteButtonStyled type="button" onClick={onClick}>
          Delete
        </DeleteButtonStyled>
      </ColumnStyled>
    </WrapStyled>
  );
};
